import { RA_MORNINGSTAR, RA_MORNINGSTAR_DBRS } from '@/creditflowresearch/domain/vo/RatingAgency/constants';

const LINKED_AGENCY_PAIRS = [
  [RA_MORNINGSTAR_DBRS, RA_MORNINGSTAR],
] as const;

const addIfMissing = (ids: string[], id: string): string[] =>
  ids.includes(id) ? ids : [...ids, id];

const removeIfPresent = (ids: string[], id: string): string[] =>
  ids.filter((existingId) => existingId !== id);

const syncLinkedAgencies = (selectedIds: string[]): string[] =>
  LINKED_AGENCY_PAIRS.reduce((acc, [primary, linked]) => {
    if (acc.includes(primary)) return addIfMissing(acc, linked);

    return removeIfPresent(acc, linked);
  }, selectedIds);

export default syncLinkedAgencies;
